<div class="fixed top-[58px] left-0 h-[calc(100dvh-58px)]  w-[58px] bg-[#F6F6F6] transition-transform duration-300 ease-in-out z-[150] lg:translate-x-0 -translate-x-full flex flex-col justify-between"
     [ngClass]="open ? 'translate-x-0' : '-translate-x-full'">

  <ul class="lg:flex hidden flex-col gap-2 p-2">
    <li>
      <a [routerLink]="['/']" matTooltip="Summary" matTooltipPosition="right" class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" routerLinkActive="bg-white !border-gray-300" [routerLinkActiveOptions]="{ exact: true }">
        <img src="../../../assets/images/icons/sidebar/dashboard.svg" alt="dashboard">
      </a>
    </li>
    <li >
      <a *ngIf="canViewPermission('ticket')" [routerLink]="['/tickets/table']" matTooltip="Tickets" matTooltipPosition="right" [ngClass]="{ 'bg-white !border-gray-300': isTicketsActive() }"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300"
      >
        <img src="../../../assets/images/icons/sidebar/ticket.svg" alt="ticket">
      </a>
    </li>
    <li *ngIf="canViewPermission('ticketsetup')">
      <a [routerLink]="['/tickets-setup']" matTooltip="Setup" matTooltipPosition="right" class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" routerLinkActive="bg-white !border-gray-300">
        <img src="../../../assets/images/icons/sidebar/setup.svg" alt="setup">
      </a>
    </li>
    <li>
      <a *ngIf="canViewPermission('hr')" [routerLink]="['/employees']" matTooltip="Employees" matTooltipPosition="right" class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" routerLinkActive="bg-white !border-gray-300">
        <img src="../../../assets/images/icons/sidebar/business-setup.svg" alt="business setup">
      </a>
    </li>
    <li>
      <a *ngIf="canViewPermission('timetracking')" [routerLink]="['/time-tracking']" matTooltip="Time Tracking" matTooltipPosition="right"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" [ngClass]="{ 'bg-white !border-gray-300': isTimeTrackingActive() }">
        <img src="../../../assets/images/icons/sidebar/calendar-edit.svg" alt="Time Tracking">
      </a>
    </li>
    <li>
      <a *ngIf="canViewPermission('hr')" [routerLink]="['/hr']" matTooltip="HR" matTooltipPosition="right"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" [ngClass]="{ 'bg-white !border-gray-300': isHrActive() }">
        <img src="../../../assets/images/icons/sidebar/people.svg" alt="HR">
      </a>
    </li>
    <!-- <li *ngIf="canViewPermission('fleetsetup')">
      <a [routerLink]="['/fleet-setup']" matTooltip="Fleet Setup" matTooltipPosition="right" class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" routerLinkActive="bg-white !border-gray-300">
        <img src="../../../assets/images/icons/sidebar/setup.svg" alt="setup">
      </a>
    </li>  -->
      <li>
        <a *ngIf="canViewPermission('transportation')" [routerLink]="['/transportation']" matTooltip="Transportation"
          matTooltipPosition="right"
          class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300"
          routerLinkActive="bg-white !border-gray-300">
          <img src="../../../assets/images/icons/sidebar/truck.svg" alt="business setup">
        </a>
      </li>
   
  </ul>

  <ul class="lg:hidden flex flex-col gap-2 p-2">
    <li>
      <a [routerLink]="['/']" (click)="closeSubmenu()" class="size-8 flex items-center justify-center rounded-full border border-transparent"
         routerLinkActive="bg-white !border-gray-300" [routerLinkActiveOptions]="{ exact: true }">
        <img src="../../../assets/images/icons/sidebar/dashboard.svg" alt="dashboard">
      </a>
    </li>

    <li *ngIf="canViewPermission('ticket')">
      <a href="javascript:void(0)" (click)="openSubmenu('ticket', 'Tickets')"
         [ngClass]="{
         'bg-white !border-gray-300': isRouteActive('ticket'),
         'bg-[#ececec]': isClicked('ticket'),
         'size-10 flex items-center justify-center rounded-full border border-transparent': true
       }">
        <img src="../../../assets/images/icons/sidebar/ticket.svg" alt="ticket">
      </a>
    </li>

    <li *ngIf="canViewPermission('ticketsetup')">
      <a href="javascript:void(0)" (click)="openSubmenu('setup', 'Setup')"
         [ngClass]="{
         'bg-white !border-gray-300': isRouteActive('setup'),
         'bg-[#ececec]': isClicked('setup'),
         'size-10 flex items-center justify-center rounded-full border border-transparent': true
       }">
        <img src="../../../assets/images/icons/sidebar/setup.svg" alt="setup">
      </a>
    </li>

    <li *ngIf="canViewPermission('employee')">
      <a href="javascript:void(0)" (click)="openSubmenu('employee', 'Business Setup')"
         [ngClass]="{
         'bg-white !border-gray-300': isRouteActive('employee'),
         'bg-[#ececec]': isClicked('employee'),
         'size-10 flex items-center justify-center rounded-full border border-transparent': true
       }">
        <img src="../../../assets/images/icons/sidebar/business-setup.svg" alt="business-setup">
      </a>
    </li>
     <li>
      <a *ngIf="canViewPermission('timetracking')" [routerLink]="['/time-tracking']" matTooltip="Time Tracking" matTooltipPosition="right"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" [ngClass]="{ 'bg-white !border-gray-300': isTimeTrackingActive() }">
        <img src="../../../assets/images/icons/sidebar/calendar-edit.svg" alt="Time Tracking">
      </a>
    </li>
    <li>
      <a *ngIf="canViewPermission('hr')" [routerLink]="['/hr']" matTooltip="HR" matTooltipPosition="right"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" [ngClass]="{ 'bg-white !border-gray-300': isHrActive() }">
        <img src="../../../assets/images/icons/sidebar/business-setup.svg" alt="HR">
      </a>
    </li>
     <li>
      <a *ngIf="canViewPermission('transportation')" [routerLink]="['/transportation']" matTooltip="Transportation" matTooltipPosition="right"
      class="size-10 flex items-center justify-center rounded-full border border-transparent hover:bg-white hover:border-gray-300" routerLinkActive="bg-white !border-gray-300">
        <img src="../../../assets/images/icons/sidebar/truck.svg" alt="Transportation">
      </a>
    </li>
    <!-- <li *ngIf="canViewPermission('timetracking')">
      <a href="javascript:void(0)" (click)="openSubmenu(moduleCodes.TimeTracking, 'Time Tracking')"
         [ngClass]="{
         'bg-white !border-gray-300': isRouteActive('time-tracking'),
         'bg-[#ececec]': isClicked('time-tracking'),
         'size-10 flex items-center justify-center rounded-full border border-transparent': true
       }">
        <img src="../../../assets/images/icons/sidebar/finance.svg" alt="time-tracking">
      </a>
    </li>

    <li>
      <a href="javascript:void(0)" (click)="openSubmenu('finance', 'Finance Management')"
         [ngClass]="{
         'bg-white !border-gray-300': isRouteActive('finance'),
         'bg-[#ececec]': isClicked('finance'),
         'size-10 flex items-center justify-center rounded-full border border-transparent': true
       }">
        <img src="../../../assets/images/icons/sidebar/finance.svg" alt="finance">
      </a>
    </li> -->
  </ul>

  <ul class="lg:hidden flex flex-col gap-1.5 items-center pb-5">
    <li class="p-2 rounded-full cursor-pointer hover:bg-[#ececec]" role="button"
        tabindex="0"  (click)="headerSearch()" (keydown.enter)="headerSearch()">
      <img src="../../../assets/images/icons/global/search.svg" alt="search">
    </li>
    <li class="p-2 rounded-full cursor-pointer hover:bg-[#ececec]" role="button"

        tabindex="0" (click)="headerNotification()" (keydown.enter)="headerNotification()">
      <img src="../../../assets/images/icons/global/notification.svg" alt="notification">
    </li>

    <li class="p-[2px] rounded-full cursor-pointer"
        [ngClass]="{

        'bg-white': isClicked('profile')
      }"
        (click)="openSubmenu('profile', 'Profile')" (keydown.enter)="openSubmenu('profile', 'Profile')" role="button"

        tabindex="0"
        *ngIf="user$ | async as _user">
      <app-avatar [userList]="[{ displayName: _user.firstName + ' ' + _user.lastName, pic: _user.pic}]"
                  [size]="'xl'"
                  [customClass]="'border-1 border-[#DBDFE9]'"
                  [showTooltip]="false"></app-avatar>
    </li>
  </ul>

</div>
